<script setup lang="ts">
import type { BlockContactFormFragment } from '#graphql-operations'

interface BlockContactFormProps {
  data: BlockContactFormFragment
}

const props = defineProps<BlockContactFormProps>()

const colorScheme = useColorScheme(() => props.data.colorScheme)
</script>

<template>
  <Section class="blockContactForm" :class="colorScheme">
    <div class="container layout-grid c-$color-scheme-foreground py-10 bg-$color-scheme-background space-y-8 lg:py-15 lg:space-y-12">
      <div class="col-span-full">
        <Text v-if="data.heading" class="richtext-simple typo-serif-4 text-center" :html="data.heading" />
      </div>
      <div class="col-span-full space-y-8 lg:col-span-4 lg:col-start-5">
        <BookForm submit-theme="scheme" />
      </div>
    </div>
  </Section>
</template>
